import PopupTemplate from "@arcgis/core/PopupTemplate.js";

export var popupTemplate = new PopupTemplate({
    title: "{title}", // Use a field from the layer
    content: function(feature) {
        var attributes = feature.graphic.attributes;
        return `${attributes.description}`}
  });